export const enum IssuanceDocumentType {
  LeaseFund = '01',
  DomesticRealEstate = '02',
  OverseasRealEstate = '03',
  AccountActivityStatement = '99',
}

export const enum IssuanceDocumentSubFolderType {
  FinancialReport = '01',
  Contract = '05',
}

export const IssuanceDocumentSubFolderTypeMap: {
  [P in IssuanceDocumentSubFolderType]: { name: string };
} = {
  [IssuanceDocumentSubFolderType.FinancialReport]: { name: '会計報告書' },
  [IssuanceDocumentSubFolderType.Contract]: { name: '契約関連書面' },
};
